import jwt from 'jsonwebtoken';
import CryptoJS from 'crypto-js';

const UserProfile = (() => {
  let cookies = (document.cookie ? document.cookie.split(";").reduce((cookieObj, cookie) => {
    const cookiePropsAndVal = cookie.split("=");
    cookieObj[cookiePropsAndVal[0].trim()] = cookiePropsAndVal[1];
    return cookieObj;
  }, {}) : {});

  const cryptoKey = process.env.CRYPTO_KEY || "b!om#12345";

  const decryptAESAlgo = (token) => {
    if (token) {
      const bytes = CryptoJS.AES.decrypt(decodeURIComponent(token), cryptoKey);
      return bytes.toString(CryptoJS.enc.Utf8);
    } else {
      return null;
    }
  }

  const decodeToken = () => {
    let token = _getToken();
    return (token ? jwt.decode(token) : {});
  }

  const _setSession = ({ token }) => {
    if (token) {
      let encryptedToken = CryptoJS.AES.encrypt(token, cryptoKey);
      cookies = {
        ...(cookies || {}),
        'token': `${encryptedToken}`,
      }
      _setCookie('token', `${encryptedToken}`, { secure: true });
    }
  }

  const _setCookie = (name, value, options = {}) => {

    options = (document.location.protocol === 'http:')? {} : options;

    options = {
      path: '/',
      ...options
    };
  
    if (options.expires instanceof Date) {
      options.expires = options.expires.toUTCString();
    }
  
    let updatedCookie = encodeURIComponent(name) + "=" + encodeURIComponent(value);
  
    for (let optionKey in options) {
      updatedCookie += "; " + optionKey;
      let optionValue = options[optionKey];
      if (optionValue !== true) {
        updatedCookie += "=" + optionValue;
      }
    }
  
    document.cookie = updatedCookie;
  }

  const _getLogonId = () => {
    const userDetails = decodeToken();
    return (userDetails.sub) ? userDetails.sub : null;
  }

  const _getUserId = () => {
    const userDetails = decodeToken();
    let detailsObj = (userDetails.user) ? JSON.parse(userDetails.user) : null;
    return (detailsObj) ? detailsObj.userId : null;
  }

  const _getFullName = () => {
    const userDetails = decodeToken();
    let detailsObj = (userDetails.user) ? JSON.parse(userDetails.user) : null;
    return (detailsObj) ? (detailsObj.firstName + " " + detailsObj.lastName) : null;
  }

  const _getToken = () => {
    return decryptAESAlgo(cookies.token);
  }

  const _clearSession = () => {
    if(document.cookie) {
      document.cookie = "token=; expire=-1;";
      cookies = '';
    }
  }

  return {
    getFullName: () => _getFullName(),
    getToken: () => _getToken(),
    clearSession: () => _clearSession(),
    setSession: (data) => _setSession(data),
    getLogonId: () => _getLogonId(),
    getUserId: () => _getUserId()
  }
})();

export default UserProfile;